import React, { PureComponent } from 'react';
import { PropTypes } from 'prop-types';
import { translate } from 'react-i18next';
import classnames from 'classnames';

import assetsFile from 'assets/plantilla-importar.csv'; // assets
import costCenterFile from 'assets/cost-center-import.csv'; // cost-center
import providersFile from 'assets/providers-import.csv'; // providers
import proyectsFile from 'assets/proyects-import.csv'; // proyects
import activeTypeFile from 'assets/tipos_activos-import.csv'; // tipo_activo
import accountsFile from 'assets/cuenta_contable-import.csv'; // cuenta_contable
import customEmployeesFile from 'assets/custom_employees-import.csv'; // custom_employees
import employeesFile from 'assets/employees-import.csv'; // employees
import locationsFile from 'assets/locations-import.csv'; // locations

import Dropzone from 'react-dropzone';
import { Form } from 'common/components';

class ImportFormFiles extends PureComponent {
  static propTypes = {
    handleFileSelected: PropTypes.func.isRequired,
    handleValueChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
    module: PropTypes.string.isRequired,
  };

  importFiles = {
    assets: { file: assetsFile, name: 'Activos' },
    cost_centers: { file: costCenterFile, name: 'Centro de costos' },
    providers: { file: providersFile, name: 'Proveedores' },
    projects: { file: proyectsFile, name: 'Proyectos' },
    tipo_activo: { file: activeTypeFile, name: 'Tipo de activo' },
    cuenta_contable: { file: accountsFile, name: 'Cuenta contable' },
    custom_employees: { file: customEmployeesFile, name: 'Custom fields empleados' },
    employees: { file: employeesFile, name: 'Empleados' },
    locations: { file: locationsFile, name: 'Ubicaciones' },
  };

  importFile = this.importFiles.assets;

  state = { active: false };

  onDragEnter = () => this.setState({ active: true });
  onDragLeave = () => this.setState({ active: false });

  componentDidMount() {
    this.props.handleValueChange({ target: { name: 'module', value: 'assets' } }, true);

    // Cambiar el value por el del modulo deseado futura mejora, para acceder a este modulo desde cualquier otro con la opcion ya seleccionada.
  }

  changeImportFile(e) {
    this.importFile = this.importFiles[e.target.value];
  }

  render = () => (
    <Form.Section title={this.props.t('import.fields.files')}>
      <a href={this.importFile.file} className="btn btn-primary mx-2 pull-right">
        {this.props.t('import.fields.csvTemplateAssets')} <i className="fa fa-cloud-download"></i>
      </a>

      <Form.FieldSelect
        autoFocus={true}
        label={this.props.t('import.fields.module')}
        name={'module'}
        handleChange={(e) => {
          this.props.handleValueChange(e);
          this.changeImportFile(e);
        }}
        value={this.props.module}
        noEmptyOption={true}
      >
        <option value="assets">{this.props.t('import.searchEditor.assets')}</option>
        <option value="providers">{this.props.t('import.searchEditor.provider')}</option>
        <option value="projects">{this.props.t('import.searchEditor.projects')}</option>
        <option value="cost_centers">{this.props.t('import.searchEditor.costCenter')}</option>
        <option value="cuenta_contable">
          {this.props.t('import.searchEditor.ledgerAccounts')}
        </option>
        <option value="tipo_activo">{this.props.t('import.searchEditor.typeAssets')}</option>
        <option value="custom_employees">
          {this.props.t('import.searchEditor.customFieldsEmployees')}
        </option>
        <option value="employees">{this.props.t('import.searchEditor.employees')}</option>
        <option value="locations">{this.props.t('import.searchEditor.locations')}</option>
      </Form.FieldSelect>

      <Dropzone
        className={classnames('files-dropzone mt-3', { active: this.state.active })}
        accept={'.csv,.CSV'}
        multiple={false}
        onDrop={this.props.handleFileSelected}
        onDragEnter={this.onDragEnter}
        onDragLeave={this.onDragLeave}
      >
        <p>
          <i className="fa fa-cloud-upload fa-lg" />
          {'  '}
          {this.state.active ? this.props.t('common.fileActive') : this.props.t('common.file')}
        </p>
      </Dropzone>
    </Form.Section>
  );
}

export default translate()(ImportFormFiles);



// WEBPACK FOOTER //
// src/modules/secured/modules/import/components/form/ImportFormFiles.js